import {useState, useCallback} from 'react';

import {OrderWithMenuVisibility} from '~/shared/store/models/User/UserReport';
import {MenuEventsProps, useMenuList} from '~/common/hooks/UserTransactions';
import SideMenu from '~/shared/components/UserTransactions/components/SideMenu';

import {Cell} from './common';

interface IMenuCell {
  menuEvents: MenuEventsProps;
  order: OrderWithMenuVisibility;
}

const MenuCell = ({order, menuEvents}: IMenuCell) => {
  const _order = {...order, id: order.orderId};
  const menuList = useMenuList(_order, menuEvents);
  const [openMenuId, setOpenMenuId] = useState<number>();

  const onMenuClick = useCallback(
    (rowId?: number) => {
      if (openMenuId === rowId || !rowId) {
        setOpenMenuId(undefined);
      } else {
        setOpenMenuId(rowId);
      }
    },
    [openMenuId],
  );

  return (
    <Cell width={40}>
      <SideMenu
        isMobile={false}
        onClick={onMenuClick}
        order={_order}
        menuList={menuList}
        openedRowMenuId={openMenuId}
        {...menuEvents}
      />
    </Cell>
  );
};

export default MenuCell;
